import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import {withStyles,Button,IconButton,Dialog,Typography
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import { ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from '@material-ui/lab/Alert';
import {getKundKontakter,CreateEsignering,getKundAvtalProspekt,onSetZeroKundSearch} from 'actions'
import {isUndefined,isEmpty} from 'lodash'
import CustomScrollbars from 'util/CustomScrollbars';
import KundInput from './KundInput'
import Kontakt from './Kontakt'
import Avtal from './Avtal'
import Esignering from './Esignering'
import moment from 'moment'

import useMediaQuery from '@material-ui/core/useMediaQuery';

const withMediaQuery = (queries = []) => Component => props => {
    const mediaProps = {}
    queries.forEach(q => {
      mediaProps[q[0]] = useMediaQuery(q[1])
    })
    return <Component {...mediaProps} {...props} />
  }

const styles = theme => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

function mapStateToProps({auth,Avtal,accountsData}) {
    const { authUser} = auth;
    const { isLoading,message,currentAvtal } = Avtal;
    const { KontakterList,KundSearch,Flags } = accountsData;
    return {
        isLoading,message,authUser,KontakterList,currentAvtal,KundSearch,Flags
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getKundKontakter: (userid,AFid,Orgnr) => dispatch(getKundKontakter(userid,AFid,Orgnr)),
        getKundAvtalProspekt: (Orgnr, Afid, userid) => dispatch(getKundAvtalProspekt(Orgnr, Afid, userid)),
        CreateEsignering: (Afid, userid,NewSignering) => dispatch(CreateEsignering(Afid, userid,NewSignering)),
        onSetZeroKundSearch: () => dispatch(onSetZeroKundSearch()),
        dispatch
    };
}
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
class PopUpES extends Component {
    state = {
        activeStep: 0,
        message: "",
        showMessage: false,
        skipped: new Set(),
        KontakterList:[],
        error:false,
        errorFile:false,
        errorMessage:<IntlMessages id="Incorrect.fields.error"/>,
        newEsignering:{
            Kund:{
                KundNamn:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].KundNamn,
                Orgnr:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Orgnr,
                Orgnr_Af:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Orgnr_Af,
                Adress:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].adress,
                Postnr:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].postnr,
                Ort:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].ort,
                Source:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Source,
                Active:isUndefined(this.props.currentKund)?"":this.props.currentKund.isActive
            },
            ansvarig:this.props.authUser.user_id,
            isPrivat:0,
            Kontakt:{
                id:"",
                FirstName:"",
                LastName:"",
                Email:"",
                Tele:"",
                PersonNr:""
            },
            Esignering:{
                Bjudain:isUndefined(this.props.Flags)?"email_mobile":this.props.Flags.ConfirmationEsigneringinvite,
                Bekraftelse:isUndefined(this.props.Flags)?"email_mobile":this.props.Flags.ConfirmationEsigneringMethod,
                Email:"",
                Tele:"",
                PersonalNr:{
                    Value:"",
                    FilledBy:false,
                    HidePerson:false,
                    Page:1,
                    Xrel:0.1,
                    Yrel:0.1
                },
                Behorigattvisa:"standard",
                Lang:"sv",
                BehorigattSkriva:isUndefined(this.props.Flags)?'standard' : this.props.Flags.DEsignMethod,
                DaedLinePaminelse:isUndefined(this.props.Flags)?0:this.props.Flags.DEsigneringDeadline,
                SkickaPaminelse:isUndefined(this.props.Flags)?14:this.props.Flags.DEsigneringPåminnelse,
                InvitationMessage:"",
            },
            Avtal:{
                new:0,
                id:0,
                typ:0,
                Lopande:0,
                Gtill:moment(new Date()).format("YYYY-MM-DD"),
                Omfor:moment(new Date()).format("YYYY-MM-DD"),
            },
            Document:{
                Typ:0,
                fileUrl:"",
                file:{}
            }
        }
    };
    componentDidUpdate=()=>{
        if(this.state.KontakterList !== this.props.KontakterList){
            this.setState({
                KontakterList:this.props.KontakterList
            })
        }
        if(this.props.KundSearch.Orgnr !== this.state.newEsignering.Kund.Orgnr){
            this.setState({
                ...this.state,
                newEsignering:{
                    ...this.state.newEsignering,
                    Kund:{
                        KundNamn:this.props.KundSearch.KundNamn,
                        Orgnr:this.props.KundSearch.Orgnr,
                        Orgnr_Af:this.props.KundSearch.Orgnr_Af,
                        Adress:this.props.KundSearch.adress,
                        Postnr:this.props.KundSearch.postnr,
                        Ort:this.props.KundSearch.ort,
                        Source:this.props.KundSearch.Source,
                        Active:this.props.KundSearch.Active,
                    
                    },
                    Kontakt:{
                        id:"",
                        FirstName:"",
                        LastName:"",
                        Email:"",
                        Tele:"",
                        PersonNr:""
                    },
                    Esignering:{
                        Bjudain:isUndefined(this.props.Flags)?"email_mobile":this.props.Flags.ConfirmationEsigneringinvite,
                        Bekraftelse:isUndefined(this.props.Flags)?"email_mobile":this.props.Flags.ConfirmationEsigneringMethod,
                        Email:"",
                        Tele:"",
                        PersonalNr:{
                            Value:"",
                            FilledBy:false,
                            HidePerson:false,
                            Page:1,
                            Xrel:0.1,
                            Yrel:0.1
                        },
                        Behorigattvisa:"standard",
                        Lang:"sv",
                        BehorigattSkriva:isUndefined(this.props.Flags)?'standard' : this.props.Flags.DEsignMethod,
                        DaedLinePaminelse:isUndefined(this.props.Flags)?0:this.props.Flags.DEsigneringDeadline,
                        SkickaPaminelse:isUndefined(this.props.Flags)?14:this.props.Flags.DEsigneringPåminnelse,
                        InvitationMessage:"",  
                    }
                }
            })
            //&& this.props.KundSearch.Source===1
            if(!isUndefined(this.props.KundSearch.Orgnr) ){
                const userid = this.props.authUser.user_id;
                const Kontoid = this.props.authUser.user_Afid;
                this.props.getKundKontakter(userid,Kontoid,this.props.KundSearch.Orgnr)
            }
        }
    }
    handleClose=()=>{
        this.props.onSetZeroKundSearch()
        this.setState({
        activeStep: 0,
        message: "",
        error:false,
        errorFile:false,
        errorMessage:<IntlMessages id="Incorrect.fields.error"/>,
        showMessage: false,
        skipped: new Set(),
        KontakterList:[],
        newEsignering:{
            Kund:{
                KundNamn:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].KundNamn,
                Orgnr:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Orgnr,
                Orgnr_Af:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Orgnr_Af,
                Adress:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].adress,
                Postnr:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].postnr,
                Ort:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].ort,
                Source:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Source,
                Active:isUndefined(this.props.currentKund)?"":this.props.currentKund.isActive
            },
            ansvarig:this.props.authUser.user_id,
            isPrivat:0,
            Kontakt:{
                id:"",
                FirstName:"",
                LastName:"",
                Email:"",
                Tele:"",
                PersonNr:""
            },
            Esignering:{
                Bjudain:isUndefined(this.props.Flags)?"email_mobile":this.props.Flags.ConfirmationEsigneringinvite,
                Bekraftelse:isUndefined(this.props.Flags)?"email_mobile":this.props.Flags.ConfirmationEsigneringMethod,
                Email:"",
                Tele:"",
                PersonalNr:{
                    Value:"",
                    FilledBy:false,
                    HidePerson:false,
                    Page:1,
                    Xrel:0.1,
                    Yrel:0.1
                },
                Behorigattvisa:"standard",
                Lang:"sv",
                BehorigattSkriva:isUndefined(this.props.Flags)?'standard' : this.props.Flags.DEsignMethod,
                DaedLinePaminelse:isUndefined(this.props.Flags)?0:this.props.Flags.DEsigneringDeadline,
                SkickaPaminelse:isUndefined(this.props.Flags)?14:this.props.Flags.DEsigneringPåminnelse,
                InvitationMessage:"",
            },
            Avtal:{
                new:0,
                id:0,
                typ:0,
                Lopande:0,
                Gtill:moment(new Date()).format("YYYY-MM-DD"),
                Omfor:moment(new Date()).format("YYYY-MM-DD"),
            },
            Document:{
                Typ:0,
                fileUrl:"",
                file:{}
            } 
        }
        })
        this.props.handleClose() 
    }
    onchangeHanelansvarig=(currenrAnsvarig)=>{
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                ansvarig:currenrAnsvarig
            }
        })
    }
    SetEsigneringKundParameters = (Meta,Value)=>{
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                Kund:{
                ...this.state.newEsignering.Kund,
                [Meta]:Value
                }
            }
        })
    }
    selectthisKund=(selectedKund)=>{
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                Kund:{
                    KundNamn:this.props.KundSearch.KundNamn,
                    Orgnr:this.props.KundSearch.Orgnr,
                    Orgnr_Af:this.props.KundSearch.Orgnr_Af,
                    Adress:this.props.KundSearch.adress,
                    Postnr:this.props.KundSearch.postnr,
                    Ort:this.props.KundSearch.ort,
                    Source:this.props.KundSearch.Source,
                    Active:this.props.KundSearch.Active,
                
                },
                Kontakt:{
                    id:"",
                    FirstName:"",
                    LastName:"",
                    Email:"",
                    Tele:"",
                    PersonNr:""
                },
                Esignering:{
                    Bjudain:isUndefined(this.props.Flags)?"email_mobile":this.props.Flags.ConfirmationEsigneringinvite,
                    Bekraftelse:isUndefined(this.props.Flags)?"email_mobile":this.props.Flags.ConfirmationEsigneringMethod,
                    Email:"",
                    Tele:"",
                    PersonalNr:{
                        Value:"",
                        FilledBy:false,
                        HidePerson:false,
                        Page:1,
                        Xrel:0.1,
                        Yrel:0.1
                    },
                    Behorigattvisa:"standard",
                    Lang:"sv",
                    BehorigattSkriva:isUndefined(this.props.Flags)?'standard' : this.props.Flags.DEsignMethod,
                    DaedLinePaminelse:isUndefined(this.props.Flags)?0:this.props.Flags.DEsigneringDeadline,
                    SkickaPaminelse:isUndefined(this.props.Flags)?14:this.props.Flags.DEsigneringPåminnelse,
                    InvitationMessage:"",  
                }
            }
        })
        //&& this.props.KundSearch.Source===1
        if(!isUndefined(this.props.KundSearch.Orgnr) ){
            const userid = this.props.authUser.user_id;
            const Kontoid = this.props.authUser.user_Afid;
            this.props.getKundKontakter(userid,Kontoid,this.props.KundSearch.Orgnr)
        }
        
    }
    onchangeHanelKontakt=(currenrKontakt)=>{
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                Kontakt:currenrKontakt,
                Esignering:{
                    ...this.state.newEsignering.Esignering,
                    Email:isEmpty(currenrKontakt.Email)?"":currenrKontakt.Email,
                    Tele:isEmpty(currenrKontakt.Tele)?"":currenrKontakt.Tele,
                    PersonalNr:isEmpty(currenrKontakt.PersonNr)?{
                        Value:"",
                        FilledBy:false,
                        HidePerson:false,
                        Page:1,
                        Xrel:0.1,
                        Yrel:0.1
                    }:{
                        Value:currenrKontakt.PersonNr,
                        FilledBy:false,
                        HidePerson:false,
                        Page:1,
                        Xrel:0.1,
                        Yrel:0.1
                    }
                }
            }
        })
    }
    onchangeHanelKontakt2=(Meta,Value)=>{
        if(Meta === 'PersonNr'){
            this.setState({
                ...this.state,
                newEsignering:{
                    ...this.state.newEsignering,
                    Kontakt:{
                    ...this.state.newEsignering.Kontakt,
                    [Meta]:Value
                    },
                    Esignering:{
                        ...this.state.newEsignering.Esignering, 
                        PersonalNr:{
                            Value:Value,
                            FilledBy:false,
                            HidePerson:false,
                            Page:1,
                            Xrel:0.1,
                            Yrel:0.1
                        }  
                    }
                }
            })
        }else{
            this.setState({
                ...this.state,
                newEsignering:{
                    ...this.state.newEsignering,
                    Kontakt:{
                    ...this.state.newEsignering.Kontakt,
                    [Meta]:Value
                    },
                    Esignering:{
                        ...this.state.newEsignering.Esignering, 
                        [Meta]:Value  
                    }
                }
            })
        }
       
    }
    onchangeHanelEsignering=(Meta,Value)=>{
        if(Meta === "Bjudain" || Meta ==="Bekraftelse"){
            this.setState({
                ...this.state,
                newEsignering:{
                    ...this.state.newEsignering,
                    Esignering:{
                        ...this.state.newEsignering.Esignering,
                        Bjudain:Value,
                        Bekraftelse:Value,
                    }
                }
            })
        }else{
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                Esignering:{
                    ...this.state.newEsignering.Esignering,
                    [Meta]:Value
                }
            }
        })
        }
    }
    onchangeHanelDocument=(Meta,Value)=>{
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                Document:{
                    ...this.state.newEsignering.Document,
                    [Meta]:Value
                }
            }
        })
    }
    onchangeHanelAvtal=(Meta,Value)=>{
        if(Meta === "new" && parseInt(Value) === 3){
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            const Orgnr = this.state.newEsignering.Kund.Orgnr;
            this.props.getKundAvtalProspekt(Orgnr,Afid,userid)
        }
        if(Meta === "new" && parseInt(Value) !== 3){
            this.setState({
                ...this.state,
                    newEsignering:{
                        ...this.state.newEsignering,
                        Avtal:{
                            ...this.state.newEsignering.Avtal,
                            id:0
                        }
                    }
            })
        }
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                Avtal:{
                    ...this.state.newEsignering.Avtal,
                    [Meta]:Value
                }
            }
        })
    }
    saveNewEsignering=()=>{
        if(this.onCheckReq()){
            console.log("error")
        }
        else{
        const userid = this.props.authUser.user_id;
        const Kontoid = this.props.authUser.user_Afid;
        this.props.CreateEsignering(Kontoid,userid,this.state.newEsignering)  
        this.handleClose()
        }
       
      //  return <Redirect to={`/app/EsigneringKort`} />
    }
    onChangeisPrivat=(isPrivat)=>{
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                isPrivat:isPrivat
            } 
        })
    }
    onChangeBefintlig=(FileUrt)=>{
        this.setState({
            ...this.state,
            newEsignering:{
                ...this.state.newEsignering,
                Document:{
                    ...this.state.newEsignering.Document,
                    fileUrl:FileUrt,
                    file:{}
                }
            }
        })
    }
    onCheckReq=()=>{
        if(
            isEmpty(this.state.newEsignering.Kund.Orgnr) ||
            isEmpty(this.state.newEsignering.Kontakt.FirstName) ||
            (isEmpty(this.state.newEsignering.Document.file) && isEmpty(this.state.newEsignering.Document.fileUrl)) ||
            isNaN(this.state.newEsignering.Kontakt.id) ||
            (
                this.state.newEsignering.Esignering.Bjudain === "email_mobile"
                &&
                this.state.newEsignering.Esignering.Tele.length === 0
                &&
                isEmpty(this.state.newEsignering.Esignering.Email)
            )
            ||
            (
                this.state.newEsignering.Esignering.Bjudain === "mobile"
                &&
                (
                    this.state.newEsignering.Esignering.Tele.length === 0
                    ||
                    this.state.newEsignering.Esignering.Tele[0] !=="+"
                )
            )
            ||
            (
                this.state.newEsignering.Esignering.Bjudain === "email"
                &&
                isEmpty(this.state.newEsignering.Esignering.Email)
            )
            ||
            (
            (
                this.state.newEsignering.Esignering.Behorigattvisa ==="se_bankid" || 
                this.state.newEsignering.Esignering.Behorigattvisa ==="no_bankid" 
            )
            &&
                this.state.newEsignering.Esignering.PersonalNr.Value.length === 0
            )
            ||
            this.state.newEsignering.Avtal.new === 0
            ||
            (
            (
                this.state.newEsignering.Avtal.new === 1
                ||
                this.state.newEsignering.Avtal.new === 2
                ) &&
                isEmpty(this.state.newEsignering.Avtal.typ)
            )
            ||
            
            this.state.newEsignering.Document.Typ === 0

        ){
            this.setState({
                error:true,
                errorFile:isEmpty(this.state.newEsignering.Document.file),
            })
            return true
        }else{
            this.setState({
                error:false,
                errorFile:false,
            })
            return false
        }
    }
    render() {
        const { fullScreen } = this.props;
            return (
                <Dialog 
                onClose={this.handleClose} 
                fullScreen={fullScreen}
                aria-labelledby="customized-dialog-title" 
                open={this.props.open} fullWidth={true}
                maxWidth={"sm"} 
                disableBackdropClick={true} 
                disableEscapeKeyDown={true}
                >
                <ModalHeader className="modal-box-header bg-primary text-white">
                <IntlMessages id="E-signing"/>
                    <IconButton className="text-white"
                        onClick={this.handleClose}>
                        <CloseIcon />
                    </IconButton>
                </ModalHeader>
                <DialogContent dividers>
                <KundInput
                isFrom={0}
                Kund={this.state.newEsignering.Kund}
                onchangeHanelKund={this.SetEsigneringKundParameters}
                selectthisKund={this.selectthisKund}
                />
                {
                isEmpty(this.state.newEsignering.Kund.Orgnr)?"":
            <>
                    <Kontakt
                    isFrom={0}
                    Kontakt={this.state.newEsignering.Kontakt}
                    isPrivat={this.state.newEsignering.isPrivat}
                    ansvarig={this.state.newEsignering.ansvarig}
                    Kontakter={isEmpty(this.state.KontakterList)?[]:this.state.KontakterList}
                    onchangeHanelKontakt={this.onchangeHanelKontakt}
                    onchangeHanelKontakt2={this.onchangeHanelKontakt2}
                    onChangeisPrivat={this.onChangeisPrivat}
                    />  
                    <Esignering
                    isFrom={0}
                    Esignering={this.state.newEsignering.Esignering}
                    onchangeHanelEsignering={this.onchangeHanelEsignering}
                    />  
                    <Avtal
                    isFrom={0}
                    EsigneringOrgnr={this.state.newEsignering.Kund.Orgnr}
                    Avtal={this.state.newEsignering.Avtal}
                    onChangeBefintlig={this.onChangeBefintlig}
                    Document={this.state.newEsignering.Document}
                    onchangeHanelAvtal={this.onchangeHanelAvtal}
                    onchangeHanelDocument={this.onchangeHanelDocument}
                    errorFile={this.state.errorFile}
                    />
            </>
                }
                </DialogContent> {
                    this.state.error? 
                        <Alert severity="warning">{this.state.errorMessage}</Alert>
                        :""
                    }
                <DialogActions> 
            
        <div className="d-flex w-100">
        <div>
            <Button
            onClick={this.handleClose}
            className="jr-btn"
            variant="outlined"
            color="default"
            >
                <IntlMessages id="Cancel"/>
            </Button>
            </div> 
            <div className="ml-auto">
                <Button
                variant="contained"
                color="primary"
                className="jr-btn"
                onClick={this.saveNewEsignering}
                ><IntlMessages id="Create"/></Button>
            </div>
        </div>          
        </DialogActions>
    </Dialog> 
    )
    }  
}
export default compose(
    withStyles(styles),
    (withMediaQuery([
        ['fullScreen', theme => theme.breakpoints.down('xs'), {
          defaultMatches: true
        }]
      ])),
    connect(mapStateToProps,mapDispatchToProps)
)(PopUpES);
